// extracted by mini-css-extract-plugin
export var blue = "_3d-f";
export var brand = "_3d-b";
export var darkGrey = "_3d-e";
export var disabled = "_3d-4";
export var disabledSubtle = "_3d-5";
export var error = "_3d-6";
export var green = "_3d-g";
export var grey = "_3d-d";
export var icon = "_3d-0";
export var inherit = "_3d-a";
export var lightGrey = "_3d-c";
export var orange = "_3d-i";
export var pink = "_3d-k";
export var primary = "_3d-1";
export var purple = "_3d-l";
export var red = "_3d-j";
export var secondary = "_3d-2";
export var success = "_3d-9";
export var tertiary = "_3d-3";
export var warning = "_3d-7";
export var warningSecondary = "_3d-8";
export var white = "_3d-m";
export var yellow = "_3d-h";